// @ts-check
import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import cx from 'classnames';
import useHideNavigation from 'modules/shell/hooks/useHideNavigation';
import { IconButton } from '@material-ui/core';
import { CloseIcon } from 'sharedComponents/Icons';

const Video = React.lazy(() => import('modules/clienteling/components/Video'));

const SearchScanner = ({
  classes,
  onClose,
  onCodeDetected,
  renderLinkButton,
  skipHideNavigationHook,
  isMasked,
  positionFixed,
  usePortal,
}) => {
  if (!skipHideNavigationHook) {
    useHideNavigation();
  }

  const onScanCompleted = (value) => {
    onCodeDetected(value);
    onClose();
  };

  const renderScanner = () => (
    <div className={cx(classes.root, positionFixed && classes.rootFixed)} data-testid="search-scanner">
      <IconButton onClick={onClose} className={classes.closeBtn} data-testid="close-search-scanner-btn">
        <CloseIcon />
      </IconButton>
      <React.Suspense fallback={<div>Loading...</div>}>
        <Video callback={onScanCompleted} isMasked={isMasked} data-testid="video-code-scanner" />
      </React.Suspense>
      {renderLinkButton && renderLinkButton()}
    </div>
  );

  if (usePortal) {
    return ReactDOM.createPortal(renderScanner(), document.body);
  }

  return renderScanner();
};

SearchScanner.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string),
  onClose: PropTypes.func,
  onCodeDetected: PropTypes.func,
  renderLinkButton: PropTypes.func,
  skipHideNavigationHook: PropTypes.bool,
  isMasked: PropTypes.bool,
  positionFixed: PropTypes.bool,
  usePortal: PropTypes.bool,
};

SearchScanner.defaultProps = {
  classes: {},
  onClose: () => {},
  onCodeDetected: () => {},
  positionFixed: false,
  usePortal: false,
};

export default SearchScanner;
